module.exports = __webpack_public_path__ + "static/media/menyja-logo.3228e1b7.svg";